/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CorporateStructureFilter = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The CorporateStructureFilter model module.
   * @module model/CorporateStructureFilter
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CorporateStructureFilter</code>.
   * @alias module:model/CorporateStructureFilter
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>CorporateStructureFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CorporateStructureFilter} obj Optional instance to populate.
   * @return {module:model/CorporateStructureFilter} The populated <code>CorporateStructureFilter</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ProductIDs')) {
        obj['ProductIDs'] = ApiClient.convertToType(data['ProductIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('GeoAreaIDs')) {
        obj['GeoAreaIDs'] = ApiClient.convertToType(data['GeoAreaIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('CustomerIDs')) {
        obj['CustomerIDs'] = ApiClient.convertToType(data['CustomerIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TrackingLevel1ItemIDs')) {
        obj['TrackingLevel1ItemIDs'] = ApiClient.convertToType(data['TrackingLevel1ItemIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TrackingLevel2ItemIDs')) {
        obj['TrackingLevel2ItemIDs'] = ApiClient.convertToType(data['TrackingLevel2ItemIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TrackingLevel3ItemIDs')) {
        obj['TrackingLevel3ItemIDs'] = ApiClient.convertToType(data['TrackingLevel3ItemIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TrackingLevel4ItemIDs')) {
        obj['TrackingLevel4ItemIDs'] = ApiClient.convertToType(data['TrackingLevel4ItemIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('CompanyLegalEntityIDs')) {
        obj['CompanyLegalEntityIDs'] = ApiClient.convertToType(data['CompanyLegalEntityIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('CompanyFunctionIDs')) {
        obj['CompanyFunctionIDs'] = ApiClient.convertToType(data['CompanyFunctionIDs'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * @member {Array.<Integer>} ProductIDs
   */
  exports.prototype['ProductIDs'] = undefined;
  /**
   * @member {Array.<Integer>} GeoAreaIDs
   */
  exports.prototype['GeoAreaIDs'] = undefined;
  /**
   * @member {Array.<Integer>} CustomerIDs
   */
  exports.prototype['CustomerIDs'] = undefined;
  /**
   * @member {Array.<Integer>} TrackingLevel1ItemIDs
   */
  exports.prototype['TrackingLevel1ItemIDs'] = undefined;
  /**
   * @member {Array.<Integer>} TrackingLevel2ItemIDs
   */
  exports.prototype['TrackingLevel2ItemIDs'] = undefined;
  /**
   * @member {Array.<Integer>} TrackingLevel3ItemIDs
   */
  exports.prototype['TrackingLevel3ItemIDs'] = undefined;
  /**
   * @member {Array.<Integer>} TrackingLevel4ItemIDs
   */
  exports.prototype['TrackingLevel4ItemIDs'] = undefined;
  /**
   * @member {Array.<Integer>} CompanyLegalEntityIDs
   */
  exports.prototype['CompanyLegalEntityIDs'] = undefined;
  /**
   * @member {Array.<Integer>} CompanyFunctionIDs
   */
  exports.prototype['CompanyFunctionIDs'] = undefined;



  return exports;
}));


